@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_049_302_279)
public val Res.string.settings_special_days_voivodeship_unknown: StringResource by lazy {
      StringResource("string:settings_special_days_voivodeship_unknown", "settings_special_days_voivodeship_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308654, 197),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440418, 293),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 282841, 165),
      ))
    }

@delegate:ResourceContentHash(131_450_990)
public val Res.string.settings_splh_goal: StringResource by lazy {
      StringResource("string:settings_splh_goal", "settings_splh_goal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309438, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441590, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283501, 66),
      ))
    }

@delegate:ResourceContentHash(566_347_810)
public val Res.string.settings_splh_goal_default: StringResource by lazy {
      StringResource("string:settings_splh_goal_default", "settings_splh_goal_default", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 308968, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440864, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283119, 70),
      ))
    }

@delegate:ResourceContentHash(-1_191_540_888)
public val Res.string.settings_splh_goal_hint: StringResource by lazy {
      StringResource("string:settings_splh_goal_hint", "settings_splh_goal_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309055, 299),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 440971, 499),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283190, 251),
      ))
    }

@delegate:ResourceContentHash(-1_323_839_132)
public val Res.string.settings_splh_goal_invalid: StringResource by lazy {
      StringResource("string:settings_splh_goal_invalid", "settings_splh_goal_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309355, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441471, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283442, 58),
      ))
    }

@delegate:ResourceContentHash(731_160_332)
public val Res.string.settings_staff_skills: StringResource by lazy {
      StringResource("string:settings_staff_skills", "settings_staff_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309509, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441693, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283568, 49),
      ))
    }

@delegate:ResourceContentHash(980_075_039)
public val Res.string.settings_sunday: StringResource by lazy {
      StringResource("string:settings_sunday", "settings_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310772, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 443548, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284743, 51),
      ))
    }

@delegate:ResourceContentHash(-399_919_445)
public val Res.string.settings_sunday_closed_desc: StringResource by lazy {
      StringResource("string:settings_sunday_closed_desc", "settings_sunday_closed_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309575, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441767, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283618, 91),
      ))
    }

@delegate:ResourceContentHash(1_732_674_915)
public val Res.string.settings_sunday_closed_title: StringResource by lazy {
      StringResource("string:settings_sunday_closed_title", "settings_sunday_closed_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309671, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441883, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283710, 44),
      ))
    }

@delegate:ResourceContentHash(350_653_644)
public val Res.string.settings_sunday_desc: StringResource by lazy {
      StringResource("string:settings_sunday_desc", "settings_sunday_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309716, 208),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 441936, 300),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283755, 188),
      ))
    }

@delegate:ResourceContentHash(-424_765_227)
public val Res.string.settings_sunday_open_desc: StringResource by lazy {
      StringResource("string:settings_sunday_open_desc", "settings_sunday_open_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 309925, 249),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 442237, 405),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283944, 241),
      ))
    }

@delegate:ResourceContentHash(1_347_554_857)
public val Res.string.settings_sunday_open_title: StringResource by lazy {
      StringResource("string:settings_sunday_open_title", "settings_sunday_open_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310175, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 442643, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284186, 50),
      ))
    }

@delegate:ResourceContentHash(1_195_866_315)
public val Res.string.settings_sunday_policy: StringResource by lazy {
      StringResource("string:settings_sunday_policy", "settings_sunday_policy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310238, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 442702, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284237, 50),
      ))
    }

@delegate:ResourceContentHash(511_156_371)
public val Res.string.settings_sunday_trading_desc: StringResource by lazy {
      StringResource("string:settings_sunday_trading_desc", "settings_sunday_trading_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310297, 400),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 442773, 684),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284288, 388),
      ))
    }

@delegate:ResourceContentHash(1_336_438_357)
public val Res.string.settings_sunday_trading_title: StringResource by lazy {
      StringResource("string:settings_sunday_trading_title", "settings_sunday_trading_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310698, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 443458, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284677, 65),
      ))
    }

@delegate:ResourceContentHash(-158_661_963)
public val Res.string.settings_swap_policy: StringResource by lazy {
      StringResource("string:settings_swap_policy", "settings_swap_policy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310824, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 443612, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284795, 44),
      ))
    }

@delegate:ResourceContentHash(311_243_067)
public val Res.string.settings_time_off_in_lieu: StringResource by lazy {
      StringResource("string:settings_time_off_in_lieu", "settings_time_off_in_lieu", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311072, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444024, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285031, 77),
      ))
    }

@delegate:ResourceContentHash(-1_425_013_682)
public val Res.string.settings_time_off_in_lieu_hint: StringResource by lazy {
      StringResource("string:settings_time_off_in_lieu_hint", "settings_time_off_in_lieu_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 310873, 198),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 443677, 346),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 284840, 190),
      ))
    }

@delegate:ResourceContentHash(-629_086_429)
public val Res.string.settings_timesheet: StringResource by lazy {
      StringResource("string:settings_timesheet", "settings_timesheet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313758, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447682, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287545, 54),
      ))
    }

@delegate:ResourceContentHash(-1_389_455_722)
public val Res.string.settings_timesheet_columns: StringResource by lazy {
      StringResource("string:settings_timesheet_columns", "settings_timesheet_columns", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311162, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444158, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285109, 46),
      ))
    }

@delegate:ResourceContentHash(31_241_025)
public val Res.string.settings_timesheet_direction: StringResource by lazy {
      StringResource("string:settings_timesheet_direction", "settings_timesheet_direction", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311890, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445086, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285725, 48),
      ))
    }

@delegate:ResourceContentHash(-785_929_449)
public val Res.string.settings_timesheet_direction_down_up: StringResource by lazy {
      StringResource("string:settings_timesheet_direction_down_up", "settings_timesheet_direction_down_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311355, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444415, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285294, 68),
      ))
    }

@delegate:ResourceContentHash(1_722_998_449)
public val Res.string.settings_timesheet_direction_down_up_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_direction_down_up_hint", "settings_timesheet_direction_down_up_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311209, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444213, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285156, 137),
      ))
    }

@delegate:ResourceContentHash(-1_047_355_619)
public val Res.string.settings_timesheet_direction_nearest: StringResource by lazy {
      StringResource("string:settings_timesheet_direction_nearest", "settings_timesheet_direction_nearest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311546, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444634, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285449, 68),
      ))
    }

@delegate:ResourceContentHash(158_028_132)
public val Res.string.settings_timesheet_direction_nearest_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_direction_nearest_hint", "settings_timesheet_direction_nearest_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311448, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444520, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285363, 85),
      ))
    }

@delegate:ResourceContentHash(-1_209_455_530)
public val Res.string.settings_timesheet_direction_up_down: StringResource by lazy {
      StringResource("string:settings_timesheet_direction_up_down", "settings_timesheet_direction_up_down", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311797, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444981, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285656, 68),
      ))
    }

@delegate:ResourceContentHash(279_067_937)
public val Res.string.settings_timesheet_direction_up_down_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_direction_up_down_hint", "settings_timesheet_direction_up_down_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311651, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 444775, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285518, 137),
      ))
    }

@delegate:ResourceContentHash(47_332_775)
public val Res.string.settings_timesheet_example: StringResource by lazy {
      StringResource("string:settings_timesheet_example", "settings_timesheet_example", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 311939, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445147, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285774, 66),
      ))
    }

@delegate:ResourceContentHash(3_563_342)
public val Res.string.settings_timesheet_hours: StringResource by lazy {
      StringResource("string:settings_timesheet_hours", "settings_timesheet_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312629, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446105, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286456, 40),
      ))
    }

@delegate:ResourceContentHash(-1_031_876_295)
public val Res.string.settings_timesheet_hours_actual: StringResource by lazy {
      StringResource("string:settings_timesheet_hours_actual", "settings_timesheet_hours_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312151, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445435, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285998, 63),
      ))
    }

@delegate:ResourceContentHash(-638_177_589)
public val Res.string.settings_timesheet_hours_actual_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_hours_actual_hint", "settings_timesheet_hours_actual_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312006, 144),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445222, 212),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 285841, 156),
      ))
    }

@delegate:ResourceContentHash(1_840_422_658)
public val Res.string.settings_timesheet_hours_combined: StringResource by lazy {
      StringResource("string:settings_timesheet_hours_combined", "settings_timesheet_hours_combined", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312378, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445766, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286225, 73),
      ))
    }

@delegate:ResourceContentHash(-988_038_941)
public val Res.string.settings_timesheet_hours_combined_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_hours_combined_hint", "settings_timesheet_hours_combined_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312219, 158),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445527, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286062, 162),
      ))
    }

@delegate:ResourceContentHash(-965_143_558)
public val Res.string.settings_timesheet_hours_plan: StringResource by lazy {
      StringResource("string:settings_timesheet_hours_plan", "settings_timesheet_hours_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312575, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446043, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286406, 49),
      ))
    }

@delegate:ResourceContentHash(2_004_754_372)
public val Res.string.settings_timesheet_hours_plan_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_hours_plan_hint", "settings_timesheet_hours_plan_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312464, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 445888, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286299, 106),
      ))
    }

@delegate:ResourceContentHash(-289_882_300)
public val Res.string.settings_timesheet_preview: StringResource by lazy {
      StringResource("string:settings_timesheet_preview", "settings_timesheet_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312674, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446154, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286497, 46),
      ))
    }

@delegate:ResourceContentHash(-1_895_381_237)
public val Res.string.settings_timesheet_remarks: StringResource by lazy {
      StringResource("string:settings_timesheet_remarks", "settings_timesheet_remarks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312825, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446373, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286648, 54),
      ))
    }

@delegate:ResourceContentHash(1_237_110_181)
public val Res.string.settings_timesheet_remarks_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_remarks_hint", "settings_timesheet_remarks_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312721, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446241, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286544, 103),
      ))
    }

@delegate:ResourceContentHash(-184_910_204)
public val Res.string.settings_timesheet_rounding: StringResource by lazy {
      StringResource("string:settings_timesheet_rounding", "settings_timesheet_rounding", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313400, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447196, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287191, 59),
      ))
    }

@delegate:ResourceContentHash(-648_893_203)
public val Res.string.settings_timesheet_rounding_minutes: StringResource by lazy {
      StringResource("string:settings_timesheet_rounding_minutes", "settings_timesheet_rounding_minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312888, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446460, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286703, 67),
      ))
    }

@delegate:ResourceContentHash(-1_499_092_863)
public val Res.string.settings_timesheet_rounding_none: StringResource by lazy {
      StringResource("string:settings_timesheet_rounding_none", "settings_timesheet_rounding_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 312964, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446564, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286771, 48),
      ))
    }

@delegate:ResourceContentHash(-246_348_549)
public val Res.string.settings_timesheet_rounding_off: StringResource by lazy {
      StringResource("string:settings_timesheet_rounding_off", "settings_timesheet_rounding_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313013, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446621, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286820, 55),
      ))
    }

@delegate:ResourceContentHash(-544_027_148)
public val Res.string.settings_timesheet_rounding_report_only: StringResource by lazy {
      StringResource("string:settings_timesheet_rounding_report_only", "settings_timesheet_rounding_report_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313077, 263),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 446697, 427),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 286876, 255),
      ))
    }

@delegate:ResourceContentHash(147_051_966)
public val Res.string.settings_timesheet_rounding_to: StringResource by lazy {
      StringResource("string:settings_timesheet_rounding_to", "settings_timesheet_rounding_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313341, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447125, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287132, 58),
      ))
    }

@delegate:ResourceContentHash(301_169_733)
public val Res.string.settings_timesheet_signature: StringResource by lazy {
      StringResource("string:settings_timesheet_signature", "settings_timesheet_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313574, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447454, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287369, 72),
      ))
    }

@delegate:ResourceContentHash(1_444_372_051)
public val Res.string.settings_timesheet_signature_hint: StringResource by lazy {
      StringResource("string:settings_timesheet_signature_hint", "settings_timesheet_signature_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313464, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447272, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287251, 117),
      ))
    }

@delegate:ResourceContentHash(-1_408_836_479)
public val Res.string.settings_timesheet_weekday: StringResource by lazy {
      StringResource("string:settings_timesheet_weekday", "settings_timesheet_weekday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313703, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447619, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287490, 54),
      ))
    }

@delegate:ResourceContentHash(-1_499_092_863)
public val Res.string.settings_timesheet_weekday_none: StringResource by lazy {
      StringResource("string:settings_timesheet_weekday_none", "settings_timesheet_weekday_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313655, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447563, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287442, 47),
      ))
    }

@delegate:ResourceContentHash(106_203_473)
public val Res.string.settings_timezone: StringResource by lazy {
      StringResource("string:settings_timezone", "settings_timezone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313813, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447757, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287600, 37),
      ))
    }

@delegate:ResourceContentHash(526_072_522)
public val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313859, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447815, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287638, 46),
      ))
    }

@delegate:ResourceContentHash(-1_621_750_415)
public val Res.string.settings_unit_days: StringResource by lazy {
      StringResource("string:settings_unit_days", "settings_unit_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313906, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447890, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287685, 34),
      ))
    }

@delegate:ResourceContentHash(615_809_806)
public val Res.string.settings_unit_hours: StringResource by lazy {
      StringResource("string:settings_unit_hours", "settings_unit_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313937, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447929, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287720, 35),
      ))
    }

@delegate:ResourceContentHash(-1_510_989_095)
public val Res.string.settings_updated: StringResource by lazy {
      StringResource("string:settings_updated", "settings_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 313973, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 447973, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287756, 48),
      ))
    }

@delegate:ResourceContentHash(607_073_985)
public val Res.string.settings_weather: StringResource by lazy {
      StringResource("string:settings_weather", "settings_weather", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314789, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449241, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288564, 56),
      ))
    }

@delegate:ResourceContentHash(948_540_764)
public val Res.string.settings_weather_hint: StringResource by lazy {
      StringResource("string:settings_weather_hint", "settings_weather_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314034, 365),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 448054, 653),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 287805, 385),
      ))
    }

@delegate:ResourceContentHash(-842_163_631)
public val Res.string.settings_weather_needs_location: StringResource by lazy {
      StringResource("string:settings_weather_needs_location", "settings_weather_needs_location", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314400, 131),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 448708, 219),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288191, 131),
      ))
    }

@delegate:ResourceContentHash(713_175_705)
public val Res.string.settings_weather_off: StringResource by lazy {
      StringResource("string:settings_weather_off", "settings_weather_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314532, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 448928, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288323, 32),
      ))
    }

@delegate:ResourceContentHash(-631_983_274)
public val Res.string.settings_weather_on: StringResource by lazy {
      StringResource("string:settings_weather_on", "settings_weather_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314577, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 448981, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288356, 31),
      ))
    }

@delegate:ResourceContentHash(-677_848_083)
public val Res.string.settings_weather_sources: StringResource by lazy {
      StringResource("string:settings_weather_sources", "settings_weather_sources", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314621, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449033, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288388, 76),
      ))
    }

@delegate:ResourceContentHash(1_327_585_289)
public val Res.string.settings_weather_switch: StringResource by lazy {
      StringResource("string:settings_weather_switch", "settings_weather_switch", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314698, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449118, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288465, 55),
      ))
    }

@delegate:ResourceContentHash(1_541_822_033)
public val Res.string.settings_weather_title: StringResource by lazy {
      StringResource("string:settings_weather_title", "settings_weather_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314750, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449194, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288521, 42),
      ))
    }

@delegate:ResourceContentHash(1_384_372_091)
public val Res.string.settings_work_places: StringResource by lazy {
      StringResource("string:settings_work_places", "settings_work_places", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314981, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449541, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288740, 56),
      ))
    }

@delegate:ResourceContentHash(-337_428_434)
public val Res.string.settings_work_places_empty: StringResource by lazy {
      StringResource("string:settings_work_places_empty", "settings_work_places_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 314846, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449342, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288621, 118),
      ))
    }

@delegate:ResourceContentHash(1_736_644_126)
public val Res.string.settings_workplace_name: StringResource by lazy {
      StringResource("string:settings_workplace_name", "settings_workplace_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315054, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449666, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288797, 51),
      ))
    }

@delegate:ResourceContentHash(-964_126_210)
public val Res.string.settings_workplace_removed: StringResource by lazy {
      StringResource("string:settings_workplace_removed", "settings_workplace_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315102, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449734, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288849, 58),
      ))
    }

@delegate:ResourceContentHash(-2_105_123_804)
public val Res.string.settings_workplace_skills: StringResource by lazy {
      StringResource("string:settings_workplace_skills", "settings_workplace_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315161, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449809, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288908, 57),
      ))
    }

@delegate:ResourceContentHash(1_208_451_142)
public val Res.string.setup_allow: StringResource by lazy {
      StringResource("string:setup_allow", "setup_allow", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315227, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449887, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288966, 27),
      ))
    }

@delegate:ResourceContentHash(-1_885_370_915)
public val Res.string.setup_camera_desc: StringResource by lazy {
      StringResource("string:setup_camera_desc", "setup_camera_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315259, 373),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 449931, 669),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 288994, 345),
      ))
    }

@delegate:ResourceContentHash(16_602_482)
public val Res.string.setup_camera_title: StringResource by lazy {
      StringResource("string:setup_camera_title", "setup_camera_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315633, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 450601, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289340, 34),
      ))
    }

@delegate:ResourceContentHash(-1_963_206_621)
public val Res.string.setup_granted: StringResource by lazy {
      StringResource("string:setup_granted", "setup_granted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315668, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 450644, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289375, 33),
      ))
    }

@delegate:ResourceContentHash(-1_926_157_871)
public val Res.string.setup_location_desc: StringResource by lazy {
      StringResource("string:setup_location_desc", "setup_location_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315702, 143),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 450682, 215),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289409, 111),
      ))
    }

@delegate:ResourceContentHash(2_124_102_619)
public val Res.string.setup_location_title: StringResource by lazy {
      StringResource("string:setup_location_title", "setup_location_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315846, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 450898, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289521, 40),
      ))
    }

@delegate:ResourceContentHash(-729_444_271)
public val Res.string.setup_notifications_desc: StringResource by lazy {
      StringResource("string:setup_notifications_desc", "setup_notifications_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 315891, 152),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 450959, 200),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289562, 120),
      ))
    }

@delegate:ResourceContentHash(-1_504_885_048)
public val Res.string.setup_notifications_title: StringResource by lazy {
      StringResource("string:setup_notifications_title", "setup_notifications_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316044, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 451160, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289683, 53),
      ))
    }

@delegate:ResourceContentHash(-1_277_790_933)
public val Res.string.shared_cost_add_title: StringResource by lazy {
      StringResource("string:shared_cost_add_title", "shared_cost_add_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316098, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 451222, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289737, 49),
      ))
    }

@delegate:ResourceContentHash(-829_559_171)
public val Res.string.shared_cost_amount: StringResource by lazy {
      StringResource("string:shared_cost_amount", "shared_cost_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316156, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 451304, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289787, 54),
      ))
    }

@delegate:ResourceContentHash(1_759_784_683)
public val Res.string.shared_cost_basis: StringResource by lazy {
      StringResource("string:shared_cost_basis", "shared_cost_basis", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316215, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 451375, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289842, 49),
      ))
    }

@delegate:ResourceContentHash(1_084_452_034)
public val Res.string.shared_cost_convert_note: StringResource by lazy {
      StringResource("string:shared_cost_convert_note", "shared_cost_convert_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316265, 304),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 451465, 452),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289892, 256),
      ))
    }

@delegate:ResourceContentHash(1_720_697_120)
public val Res.string.shared_cost_convert_title: StringResource by lazy {
      StringResource("string:shared_cost_convert_title", "shared_cost_convert_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316570, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 451918, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290149, 65),
      ))
    }

@delegate:ResourceContentHash(-495_763_251)
public val Res.string.shared_cost_converted: StringResource by lazy {
      StringResource("string:shared_cost_converted", "shared_cost_converted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316640, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452028, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290215, 65),
      ))
    }

@delegate:ResourceContentHash(1_925_332_065)
public val Res.string.shared_cost_date: StringResource by lazy {
      StringResource("string:shared_cost_date", "shared_cost_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316710, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452134, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290281, 48),
      ))
    }

@delegate:ResourceContentHash(-1_373_766_431)
public val Res.string.shared_cost_delete_confirm: StringResource by lazy {
      StringResource("string:shared_cost_delete_confirm", "shared_cost_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316751, 154),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452191, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290330, 134),
      ))
    }

@delegate:ResourceContentHash(-2_011_706_553)
public val Res.string.shared_cost_deleted: StringResource by lazy {
      StringResource("string:shared_cost_deleted", "shared_cost_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316906, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452402, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290465, 55),
      ))
    }

@delegate:ResourceContentHash(1_636_936_040)
public val Res.string.shared_cost_edit_title: StringResource by lazy {
      StringResource("string:shared_cost_edit_title", "shared_cost_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 316966, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452494, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290521, 54),
      ))
    }

@delegate:ResourceContentHash(1_885_453_912)
public val Res.string.shared_cost_end_month: StringResource by lazy {
      StringResource("string:shared_cost_end_month", "shared_cost_end_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317025, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452593, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290576, 37),
      ))
    }

@delegate:ResourceContentHash(456_964_148)
public val Res.string.shared_cost_error_amounts: StringResource by lazy {
      StringResource("string:shared_cost_error_amounts", "shared_cost_error_amounts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317071, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452631, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290614, 85),
      ))
    }

@delegate:ResourceContentHash(2_104_403_460)
public val Res.string.shared_cost_error_basis: StringResource by lazy {
      StringResource("string:shared_cost_error_basis", "shared_cost_error_basis", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317169, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452761, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290700, 71),
      ))
    }

@delegate:ResourceContentHash(2_056_872_760)
public val Res.string.shared_cost_error_end: StringResource by lazy {
      StringResource("string:shared_cost_error_end", "shared_cost_error_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317253, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 452889, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290772, 85),
      ))
    }

@delegate:ResourceContentHash(-1_095_626_152)
public val Res.string.shared_cost_error_negative: StringResource by lazy {
      StringResource("string:shared_cost_error_negative", "shared_cost_error_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317363, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453031, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290858, 70),
      ))
    }

@delegate:ResourceContentHash(1_786_820_346)
public val Res.string.shared_cost_error_not_owned: StringResource by lazy {
      StringResource("string:shared_cost_error_not_owned", "shared_cost_error_not_owned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317438, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453142, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 290929, 107),
      ))
    }

@delegate:ResourceContentHash(-450_848_389)
public val Res.string.shared_cost_error_percentages: StringResource by lazy {
      StringResource("string:shared_cost_error_percentages", "shared_cost_error_percentages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317542, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453314, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291037, 85),
      ))
    }

@delegate:ResourceContentHash(-1_121_280_648)
public val Res.string.shared_cost_error_workplaces: StringResource by lazy {
      StringResource("string:shared_cost_error_workplaces", "shared_cost_error_workplaces", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317648, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453432, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291123, 76),
      ))
    }

@delegate:ResourceContentHash(-636_907_254)
public val Res.string.shared_cost_frequency: StringResource by lazy {
      StringResource("string:shared_cost_frequency", "shared_cost_frequency", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317729, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453545, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291200, 41),
      ))
    }

@delegate:ResourceContentHash(-2_040_876_968)
public val Res.string.shared_cost_method: StringResource by lazy {
      StringResource("string:shared_cost_method", "shared_cost_method", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317775, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453595, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291242, 42),
      ))
    }

@delegate:ResourceContentHash(839_152_914)
public val Res.string.shared_cost_months_between: StringResource by lazy {
      StringResource("string:shared_cost_months_between", "shared_cost_months_between", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317826, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453658, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291285, 70),
      ))
    }

@delegate:ResourceContentHash(1_655_493_461)
public val Res.string.shared_cost_months_from: StringResource by lazy {
      StringResource("string:shared_cost_months_from", "shared_cost_months_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317897, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453753, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291356, 55),
      ))
    }

@delegate:ResourceContentHash(1_587_386_956)
public val Res.string.shared_cost_name_hint: StringResource by lazy {
      StringResource("string:shared_cost_name_hint", "shared_cost_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 317953, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453833, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291412, 77),
      ))
    }

@delegate:ResourceContentHash(-1_210_397_864)
public val Res.string.shared_cost_no_end: StringResource by lazy {
      StringResource("string:shared_cost_no_end", "shared_cost_no_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 318063, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 453971, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291490, 34),
      ))
    }

@delegate:ResourceContentHash(-919_079_918)
public val Res.string.shared_cost_note_equal: StringResource by lazy {
      StringResource("string:shared_cost_note_equal", "shared_cost_note_equal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 318106, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 454022, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291525, 118),
      ))
    }

@delegate:ResourceContentHash(563_808_934)
public val Res.string.shared_cost_note_income: StringResource by lazy {
      StringResource("string:shared_cost_note_income", "shared_cost_note_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 318241, 223),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 454217, 299),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 291644, 183),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString37Resources(map: MutableMap<String, StringResource>) {
  map.put("settings_special_days_voivodeship_unknown", Res.string.settings_special_days_voivodeship_unknown)
  map.put("settings_splh_goal", Res.string.settings_splh_goal)
  map.put("settings_splh_goal_default", Res.string.settings_splh_goal_default)
  map.put("settings_splh_goal_hint", Res.string.settings_splh_goal_hint)
  map.put("settings_splh_goal_invalid", Res.string.settings_splh_goal_invalid)
  map.put("settings_staff_skills", Res.string.settings_staff_skills)
  map.put("settings_sunday", Res.string.settings_sunday)
  map.put("settings_sunday_closed_desc", Res.string.settings_sunday_closed_desc)
  map.put("settings_sunday_closed_title", Res.string.settings_sunday_closed_title)
  map.put("settings_sunday_desc", Res.string.settings_sunday_desc)
  map.put("settings_sunday_open_desc", Res.string.settings_sunday_open_desc)
  map.put("settings_sunday_open_title", Res.string.settings_sunday_open_title)
  map.put("settings_sunday_policy", Res.string.settings_sunday_policy)
  map.put("settings_sunday_trading_desc", Res.string.settings_sunday_trading_desc)
  map.put("settings_sunday_trading_title", Res.string.settings_sunday_trading_title)
  map.put("settings_swap_policy", Res.string.settings_swap_policy)
  map.put("settings_time_off_in_lieu", Res.string.settings_time_off_in_lieu)
  map.put("settings_time_off_in_lieu_hint", Res.string.settings_time_off_in_lieu_hint)
  map.put("settings_timesheet", Res.string.settings_timesheet)
  map.put("settings_timesheet_columns", Res.string.settings_timesheet_columns)
  map.put("settings_timesheet_direction", Res.string.settings_timesheet_direction)
  map.put("settings_timesheet_direction_down_up", Res.string.settings_timesheet_direction_down_up)
  map.put("settings_timesheet_direction_down_up_hint", Res.string.settings_timesheet_direction_down_up_hint)
  map.put("settings_timesheet_direction_nearest", Res.string.settings_timesheet_direction_nearest)
  map.put("settings_timesheet_direction_nearest_hint", Res.string.settings_timesheet_direction_nearest_hint)
  map.put("settings_timesheet_direction_up_down", Res.string.settings_timesheet_direction_up_down)
  map.put("settings_timesheet_direction_up_down_hint", Res.string.settings_timesheet_direction_up_down_hint)
  map.put("settings_timesheet_example", Res.string.settings_timesheet_example)
  map.put("settings_timesheet_hours", Res.string.settings_timesheet_hours)
  map.put("settings_timesheet_hours_actual", Res.string.settings_timesheet_hours_actual)
  map.put("settings_timesheet_hours_actual_hint", Res.string.settings_timesheet_hours_actual_hint)
  map.put("settings_timesheet_hours_combined", Res.string.settings_timesheet_hours_combined)
  map.put("settings_timesheet_hours_combined_hint", Res.string.settings_timesheet_hours_combined_hint)
  map.put("settings_timesheet_hours_plan", Res.string.settings_timesheet_hours_plan)
  map.put("settings_timesheet_hours_plan_hint", Res.string.settings_timesheet_hours_plan_hint)
  map.put("settings_timesheet_preview", Res.string.settings_timesheet_preview)
  map.put("settings_timesheet_remarks", Res.string.settings_timesheet_remarks)
  map.put("settings_timesheet_remarks_hint", Res.string.settings_timesheet_remarks_hint)
  map.put("settings_timesheet_rounding", Res.string.settings_timesheet_rounding)
  map.put("settings_timesheet_rounding_minutes", Res.string.settings_timesheet_rounding_minutes)
  map.put("settings_timesheet_rounding_none", Res.string.settings_timesheet_rounding_none)
  map.put("settings_timesheet_rounding_off", Res.string.settings_timesheet_rounding_off)
  map.put("settings_timesheet_rounding_report_only", Res.string.settings_timesheet_rounding_report_only)
  map.put("settings_timesheet_rounding_to", Res.string.settings_timesheet_rounding_to)
  map.put("settings_timesheet_signature", Res.string.settings_timesheet_signature)
  map.put("settings_timesheet_signature_hint", Res.string.settings_timesheet_signature_hint)
  map.put("settings_timesheet_weekday", Res.string.settings_timesheet_weekday)
  map.put("settings_timesheet_weekday_none", Res.string.settings_timesheet_weekday_none)
  map.put("settings_timezone", Res.string.settings_timezone)
  map.put("settings_title", Res.string.settings_title)
  map.put("settings_unit_days", Res.string.settings_unit_days)
  map.put("settings_unit_hours", Res.string.settings_unit_hours)
  map.put("settings_updated", Res.string.settings_updated)
  map.put("settings_weather", Res.string.settings_weather)
  map.put("settings_weather_hint", Res.string.settings_weather_hint)
  map.put("settings_weather_needs_location", Res.string.settings_weather_needs_location)
  map.put("settings_weather_off", Res.string.settings_weather_off)
  map.put("settings_weather_on", Res.string.settings_weather_on)
  map.put("settings_weather_sources", Res.string.settings_weather_sources)
  map.put("settings_weather_switch", Res.string.settings_weather_switch)
  map.put("settings_weather_title", Res.string.settings_weather_title)
  map.put("settings_work_places", Res.string.settings_work_places)
  map.put("settings_work_places_empty", Res.string.settings_work_places_empty)
  map.put("settings_workplace_name", Res.string.settings_workplace_name)
  map.put("settings_workplace_removed", Res.string.settings_workplace_removed)
  map.put("settings_workplace_skills", Res.string.settings_workplace_skills)
  map.put("setup_allow", Res.string.setup_allow)
  map.put("setup_camera_desc", Res.string.setup_camera_desc)
  map.put("setup_camera_title", Res.string.setup_camera_title)
  map.put("setup_granted", Res.string.setup_granted)
  map.put("setup_location_desc", Res.string.setup_location_desc)
  map.put("setup_location_title", Res.string.setup_location_title)
  map.put("setup_notifications_desc", Res.string.setup_notifications_desc)
  map.put("setup_notifications_title", Res.string.setup_notifications_title)
  map.put("shared_cost_add_title", Res.string.shared_cost_add_title)
  map.put("shared_cost_amount", Res.string.shared_cost_amount)
  map.put("shared_cost_basis", Res.string.shared_cost_basis)
  map.put("shared_cost_convert_note", Res.string.shared_cost_convert_note)
  map.put("shared_cost_convert_title", Res.string.shared_cost_convert_title)
  map.put("shared_cost_converted", Res.string.shared_cost_converted)
  map.put("shared_cost_date", Res.string.shared_cost_date)
  map.put("shared_cost_delete_confirm", Res.string.shared_cost_delete_confirm)
  map.put("shared_cost_deleted", Res.string.shared_cost_deleted)
  map.put("shared_cost_edit_title", Res.string.shared_cost_edit_title)
  map.put("shared_cost_end_month", Res.string.shared_cost_end_month)
  map.put("shared_cost_error_amounts", Res.string.shared_cost_error_amounts)
  map.put("shared_cost_error_basis", Res.string.shared_cost_error_basis)
  map.put("shared_cost_error_end", Res.string.shared_cost_error_end)
  map.put("shared_cost_error_negative", Res.string.shared_cost_error_negative)
  map.put("shared_cost_error_not_owned", Res.string.shared_cost_error_not_owned)
  map.put("shared_cost_error_percentages", Res.string.shared_cost_error_percentages)
  map.put("shared_cost_error_workplaces", Res.string.shared_cost_error_workplaces)
  map.put("shared_cost_frequency", Res.string.shared_cost_frequency)
  map.put("shared_cost_method", Res.string.shared_cost_method)
  map.put("shared_cost_months_between", Res.string.shared_cost_months_between)
  map.put("shared_cost_months_from", Res.string.shared_cost_months_from)
  map.put("shared_cost_name_hint", Res.string.shared_cost_name_hint)
  map.put("shared_cost_no_end", Res.string.shared_cost_no_end)
  map.put("shared_cost_note_equal", Res.string.shared_cost_note_equal)
  map.put("shared_cost_note_income", Res.string.shared_cost_note_income)
}
